import React, { useState } from 'react';
import _ from 'lodash';
import { useAccordionToggle } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/hybrid/core/Icon.atom';

interface CustomToggleProps {
  eventKey: string;
  label: string | React.ReactElement;
  showDivider?: boolean;
  Component: Function;
}

/**
 * Custom toggle handler for react-bootstrap accordion
 */
export const CustomToggle: React.FunctionComponent<CustomToggleProps> = ({
  eventKey,
  label,
  showDivider = false,
  Component,
}) => {
  const [isCardOpen, setCardOpen] = useState(false);

  const decoratedOnClick = useAccordionToggle(eventKey, () => setCardOpen(!isCardOpen));

  return Component({
    onClick: decoratedOnClick,
    isCardOpen,
    label,
    showDivider,
  });
};

type TogglerProps = {
  isCardOpen: boolean;
  onClick: (e: any) => void;
  label: string | React.ReactElement;
  showDivider: boolean;
};

export const Toggler = ({ isCardOpen, onClick, label, showDivider }: TogglerProps) => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="flexColumnContainer flexSpaceBetween flexAlignCenter cursorPointer" onClick={onClick}>
        {_.isString(label) ? <span>{t(label)}</span> : label}
        <Icon icon={isCardOpen ? 'fa-chevron-down' : 'fa-chevron-right'} testId="togglerIcon" />
      </h4>
      {showDivider && <hr className="mt10 mb10" />}
    </>
  );
};
